import '.a{display:grid;}.ssr-plugin'
import '.h{gap:1.5rem;}.ssr-plugin'
import '.gf{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import useDateFormat from '@app/util/useDateFormat'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { pages } from '@app/util/links'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { styled } from 'inlines'
import { useQuery } from '@based/sdk/react'
import { useLocation } from 'wouter'
import Column from '@app/components/layout/Column'
import { Stories } from '@schema/stories'

const COUNT = 3

type StoryItem = Pick<
  Stories,
  'id' | 'title' | 'slug' | 'intro' | 'images' | 'category' | 'publishedAt'
>

export const StoriesSection = () => {
  const [, navigate] = useLocation()
  const t = useTranslations().app
  const dateFormat = useDateFormat()
  const storiesQuery = useQuery('list-stories', { top: COUNT })
  const stories: StoryItem[] = storiesQuery.data ?? []

  if (stories.length === 0) {
    return null
  }

  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.landingPage.blogSection.title}
        subtitle={t.landingPage.blogSection.subTitle}
        seeMore={t.landingPage.blogSection.seeMore}
        toRoute={pages.blogs('verhalen')}
      />
      <styled.div className="a h gf"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },
        }}
      >
        {stories.map((story) => (
          <BlogCard
            key={story.id}
            image={story.images?.[0]?.src ?? ''}
            meta={
              story.category ??
              (story.publishedAt ? dateFormat(new Date(story.publishedAt)) : '')
            }
            title={story.title}
            intro={story.intro}
            orientation="vertical"
            onClick={() => navigate(pages.blog('verhalen', story.slug))}
          />
        ))}
      </styled.div>
    </Column>
  )
}
